export default "__VITE_ASSET__3029f75a__"